// Simple currency + number formatting helpers (Indian locale)

export function formatINR(value, opts = {}) {
  const { compact = false, decimals = 0 } = opts;
  if (value === null || value === undefined || isNaN(value)) return '₹ 0';
  const num = Number(value);

  if (compact) {
    const absN = Math.abs(num);
    if (absN >= 1e7) return `₹ ${(num / 1e7).toFixed(decimals || 2)} Cr`;
    if (absN >= 1e5) return `₹ ${(num / 1e5).toFixed(decimals || 2)} L`;
    if (absN >= 1e3) return `₹ ${(num / 1e3).toFixed(decimals || 1)} K`;
  }

  return `₹ ${num.toLocaleString('en-IN', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  })}`;
}

export function formatKWh(value, decimals = 0) {
  if (value === null || value === undefined || isNaN(value)) return '0 kWh';
  return `${Number(value).toLocaleString('en-IN', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  })} kWh`;
}

export function formatNumber(value, decimals = 0) {
  if (value === null || value === undefined || isNaN(value)) return '0';
  return Number(value).toLocaleString('en-IN', {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  });
}
